export const typeScale = {
  header1: "3.75rem",
  header2: "2.5rem",
  header3: "2rem",
  header4: "1.5rem",
  normal: "0.850rem",
  small: "0.750rem",
};
